import type { EStatisticsCalculationType } from 'common/enum/misc.enum';

type CompetenceTrendParams = {
  classId: number;
  studentId: number;
  subjectId?: number | null;
  competenceDomainId?: number | null;
  competenceId?: number | null;
  performanceAssessmentId?: number | null;
  from?: string;
  to?: string;
  calculationType?: EStatisticsCalculationType;
};

export const competenceTrendKeys = {
  all: ['competenceTrend'],

  trend: (params: CompetenceTrendParams) => [
    ...competenceTrendKeys.all,
    params.classId,
    params.studentId,
    params.subjectId ?? null,
    params.competenceDomainId ?? null,
    params.competenceId ?? null,
    params.performanceAssessmentId ?? null,
    params.from ?? null,
    params.to ?? null,
    params.calculationType ?? null,
  ],
} as const;
